

// import React, { useState, useEffect, useRef } from "react";
// import { useHistory, useLocation, useParams } from "react-router-dom";
// import Swal from "sweetalert2";
// import Spinner from "react-bootstrap/Spinner";
// import { Smartphone, Lock, ShieldCheck, ArrowRight, RefreshCw } from "lucide-react";
// import { apiRequest } from "../../apiService/allApi";
// import "../css/login.css"

// export default function Login() {
//   const history = useHistory();
//   const location = useLocation();
//   const { referralcode } = useParams();

//   const [Phone, setPhone] = useState("");
//   const [twofactor_code, settwofactor_code] = useState("");
//   const [otp, setOtp] = useState(false);
//   const [isLoading1, setIsloading1] = useState(false);
//   const [secretCode, setSecretCode] = useState();
//   const [isValid, setIsValid] = useState(false);
//   const [seconds, setSeconds] = useState(60);

//   const otpInputRef = useRef(null);

//   const referral = referralcode || location.pathname.split("/")[2] || "";

//   // Timer logic for OTP Resend
//   useEffect(() => {
//     let timerInterval;
//     if (isValid && seconds > 0) {
//       timerInterval = setInterval(() => setSeconds((prev) => prev - 1), 1000);
//     } else {
//       clearInterval(timerInterval);
//       setIsValid(false);
//     }
//     return () => clearInterval(timerInterval);
//   }, [isValid, seconds]);

//   // Web OTP API Support (Auto-fill SMS OTP on mobile browsers)
//   useEffect(() => {
//     if (otp && "OTPCredential" in window) {
//       const ac = new AbortController();
//       navigator.credentials
//         .get({
//           otp: { transport: ["sms"] },
//           signal: ac.signal,
//         })
//         .then((otpObj) => {
//           if (otpObj && otpObj.code) {
//             settwofactor_code(otpObj.code);
//             // SweetAlert notification when auto-filled
//             Swal.fire({
//               toast: true,
//               position: "top",
//               icon: "info",
//               title: "OTP Auto-filled from SMS!",
//               showConfirmButton: false,
//               timer: 3000,
//               background: "#1e1e2d",
//               color: "#ffffff",
//             });
//           }
//         })
//         .catch(() => {
//           // Fallback gracefully if OTP retrieval fails or user cancels
//         });

//       return () => ac.abort();
//     }
//   }, [otp]);

//   // Handle Requesting OTP
//   const handleClick = async (e) => {
//     e?.preventDefault();
//     if (!Phone || Phone.length !== 10) {
//       return Swal.fire({
//         icon: "warning",
//         title: "Invalid Mobile Number",
//         text: "Please enter a valid 10-digit mobile number.",
//         background: "#181824",
//         color: "#ffffff",
//         confirmButtonColor: "#6366f1",
//       });
//     }

//     setIsloading1(true);
//     const respone = await apiRequest("login", "POST", { Phone, referral });
//     setIsloading1(false);

//     if (respone?.data?.status === 200) {
//       setOtp(true);
//       setIsValid(true);
//       setSeconds(60);
//       setSecretCode(respone?.data?.secret);

//       let textMsg = "Verification code has been send.";
//       if (respone?.data?.myToken) {
//         textMsg += `\n\nDemo OTP: ${respone?.data?.myToken}`;
//       }

//       Swal.fire({
//         icon: "success",
//         title: "OTP Sent!",
//         text: textMsg,
//         background: "#181824",
//         color: "#ffffff",
//         confirmButtonColor: "#6366f1",
//       });
//     } else {
//       Swal.fire({
//         icon: "error",
//         title: "Request Failed",
//         text: respone?.data?.msg || "Login failed. Please try again.",
//         background: "#181824",
//         color: "#ffffff",
//         confirmButtonColor: "#ef4444",
//       });
//     }
//   };

//   // Handle Verifying OTP
//   const varifyOtp = async (e) => {
//     e.preventDefault();
//     setIsloading1(true);
//     try {
//       const response = await apiRequest("login/finish", "POST", {
//         Phone,
//         twofactor_code,
//         referral,
//         secretCode,
//       });
//       setIsloading1(false);

//       if (response?.data?.status === 200) {
//         Swal.fire({
//           icon: "success",
//           title: "Verified!",
//           text: "Verification successful! Redirecting...",
//           timer: 1500,
//           showConfirmButton: false,
//           background: "#181824",
//           color: "#ffffff",
//         });

//         localStorage.setItem("token", response?.data?.token);
//         setTimeout(() => {
//           window.location.reload(true);
//           history.push("/Games");
//         }, 1000);
//       } else {
//         Swal.fire({
//           icon: "error",
//           title: "Verification Failed",
//           text: response?.data?.msg || "Invalid OTP. Please try again.",
//           background: "#181824",
//           color: "#ffffff",
//           confirmButtonColor: "#ef4444",
//         });
//       }
//     } catch (error) {
//       setIsloading1(false);
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "Error verifying OTP. Please try again.",
//         background: "#181824",
//         color: "#ffffff",
//         confirmButtonColor: "#ef4444",
//       });
//     }
//   };

//   return (
//     <div className="classic-page-wrapper">
//       {/* Dynamic Background Glow Elements */}
//       <div className="ambient-glow glow-1"></div>
//       <div className="ambient-glow glow-2"></div>
//       <div className="ambient-glow glow-3"></div>

//       <div className="classic-card">
//         {/* Top Branding Section */}
//         <div className="classic-header">
//           <div className="logo-badge">
//             <img src="/krludo.png" alt="KRLUDO" className="brand-logo" />
//           </div>
//           <h2 className="brand-title">Welcome Back</h2>
//           <p className="brand-subtitle">
//             {otp
//               ? "Enter the 6-digit verification code sent to your phone"
//               : "Enter your 10-digit mobile number to get started"}
//           </p>
//         </div>

//         {/* Input Form */}
//         <form onSubmit={otp ? varifyOtp : handleClick} className="classic-form">
//           <div className="input-field-group">
//             <label className="field-label">Mobile Number</label>
//             <div className={`input-wrapper ${otp ? "readonly" : ""}`}>
//               <span className="country-tag">+91</span>
//               <input
//                 type="tel"
//                 className="classic-input"
//                 placeholder="Enter Phone Number"
//                 value={Phone}
//                 disabled={otp}
//                 onChange={(e) =>
//                   setPhone(e.target.value.replace(/\D/g, "").slice(0, 10))
//                 }
//                 required
//               />
//               <Smartphone className="input-icon" size={18} />
//             </div>
//           </div>

//           {otp && (
//             <div className="input-field-group animate-slide-up">
//               <div className="label-row">
//                 <label className="field-label">Verification OTP</label>
//                 <span className="security-badge">
//                   <ShieldCheck size={14} /> Encrypted
//                 </span>
//               </div>
//               <div className="input-wrapper">
//                 <input
//                   ref={otpInputRef}
//                   type="text"
//                   className="classic-input otp-input"
//                   placeholder="• • • • • •"
//                   maxLength={6}
//                   value={twofactor_code}
//                   autoComplete="one-time-code"
//                   inputMode="numeric"
//                   onChange={(e) =>
//                     settwofactor_code(
//                       e.target.value.replace(/\D/g, "").slice(0, 6)
//                     )
//                   }
//                   required
//                   autoFocus
//                 />
//                 <Lock className="input-icon" size={18} />
//               </div>

//               {/* Timer & Resend Option */}
//               <div className="timer-container">
//                 {seconds > 0 ? (
//                   <span className="timer-text">
//                     Resend available in <strong>{seconds}s</strong>
//                   </span>
//                 ) : (
//                   <button
//                     type="button"
//                     className="resend-btn"
//                     onClick={handleClick}
//                     disabled={isLoading1}
//                   >
//                     <RefreshCw size={14} className={isLoading1 ? "spin" : ""} />{" "}
//                     Resend OTP
//                   </button>
//                 )}
//               </div>
//             </div>
//           )}

//           {/* Action Button */}
//           <button
//             type="submit"
//             className="classic-submit-btn"
//             disabled={isLoading1}
//           >
//             {isLoading1 ? (
//               <Spinner animation="border" size="sm" />
//             ) : (
//               <>
//                 <span>{otp ? "Verify & Continue" : "Send OTP"}</span>
//                 <ArrowRight size={18} />
//               </>
//             )}
//           </button>
//         </form>

//         {/* Footer info */}
//         <div className="classic-footer">
//           <p>Protected by end-to-end security protocol</p>
//         </div>
//       </div>
//     </div>
//   );
// }


import React, { useState, useEffect, useRef } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Spinner from "react-bootstrap/Spinner";
import { Phone, Lock, Shield, Sparkles, ArrowLeft } from "lucide-react";
import { apiRequest } from "../../apiService/allApi";
import "../css/login.css";

export default function Login() {
  const history = useHistory();
  const location = useLocation();
  const { referralcode } = useParams();

  const [PhoneNo, setPhoneNo] = useState("");
  const [twofactor_code, settwofactor_code] = useState("");
  const [otp, setOtp] = useState(false);
  const [isLoading1, setIsloading1] = useState(false);
  const [secretCode, setSecretCode] = useState();
  const [isValid, setIsValid] = useState(false);
  const [seconds, setSeconds] = useState(60);

  const otpInputRef = useRef(null);
  const referral = referralcode || location.pathname.split("/")[2] || "";

  // Timer logic for OTP Resend
  useEffect(() => {
    let timerInterval;
    if (isValid && seconds > 0) {
      timerInterval = setInterval(() => setSeconds((prev) => prev - 1), 1000);
    } else {
      clearInterval(timerInterval);
      setIsValid(false);
    }
    return () => clearInterval(timerInterval);
  }, [isValid, seconds]);

  // Web OTP API Support
  useEffect(() => {
    if (otp && "OTPCredential" in window) {
      const ac = new AbortController();
      navigator.credentials
        .get({
          otp: { transport: ["sms"] },
          signal: ac.signal,
        })
        .then((otpObj) => {
          if (otpObj && otpObj.code) {
            settwofactor_code(otpObj.code);
            Swal.fire({
              toast: true,
              position: "top",
              icon: "info",
              title: "OTP Auto-filled from SMS!",
              showConfirmButton: false,
              timer: 3000,
              background: "#0d131a",
              color: "#ffffff",
            });
          }
        })
        .catch(() => {});

      return () => ac.abort();
    }
  }, [otp]);

  // Handle Requesting OTP
  const handleClick = async (e) => {
    e?.preventDefault();
    if (!PhoneNo || PhoneNo.length !== 10) {
      return Swal.fire({
        icon: "warning",
        title: "Invalid Mobile Number",
        text: "Please enter a valid 10-digit mobile number.",
        background: "#0d131a",
        color: "#ffffff",
        confirmButtonColor: "#10b981",
      });
    }

    setIsloading1(true);
    const respone = await apiRequest("login", "POST", { Phone: PhoneNo, referral });
    setIsloading1(false);

    if (respone?.data?.status === 200) {
      setOtp(true);
      setIsValid(true);
      setSeconds(60);
      setSecretCode(respone?.data?.secret);

      let textMsg = "Verification code has been send.";
      if (respone?.data?.myToken) {
        textMsg += `\n\nDemo OTP: ${respone?.data?.myToken}`;
      }

      Swal.fire({
        icon: "success",
        title: "OTP Sent!",
        text: textMsg,
        background: "#0d131a",
        color: "#ffffff",
        confirmButtonColor: "#10b981",
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Request Failed",
        text: respone?.data?.msg || "Login failed. Please try again.",
        background: "#0d131a",
        color: "#ffffff",
        confirmButtonColor: "#f43f5e",
      });
    }
  };

  // Handle Verifying OTP
  const varifyOtp = async (e) => {
    e.preventDefault();
    setIsloading1(true);
    try {
      const response = await apiRequest("login/finish", "POST", {
        Phone: PhoneNo,
        twofactor_code,
        referral,
        secretCode,
      });
      setIsloading1(false);

      if (response?.data?.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Verified!",
          text: "Verification successful! Redirecting...",
          timer: 1500,
          showConfirmButton: false,
          background: "#0d131a",
          color: "#ffffff",
        });

        localStorage.setItem("token", response?.data?.token);
        setTimeout(() => {
          window.location.reload(true);
          history.push("/Games");
        }, 1000);
      } else {
        Swal.fire({
          icon: "error",
          title: "Verification Failed",
          text: response?.data?.msg || "Invalid OTP. Please try again.",
          background: "#0d131a",
          color: "#ffffff",
          confirmButtonColor: "#f43f5e",
        });
      }
    } catch (error) {
      setIsloading1(false);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Error verifying OTP. Please try again.",
        background: "#0d131a",
        color: "#ffffff",
        confirmButtonColor: "#f43f5e",
      });
    }
  };

  return (
    <div className="ce-login-wrapper mt-5 pt-5">
      <div className="ce-login-container">
        {/* Brand Header */}
        <div className="ce-brand-header">
          <div className="ce-logo-box">
            <img src="/krludo.png" alt="KRLUDO" className="ce-brand-logo" />
          </div>
          <h1 className="ce-brand-title">KRLUDO</h1>
          <p className="ce-brand-subtitle">
            <Shield size={14} className="ce-shield-icon" /> Secure login
          </p>
        </div>

        {/* Main Card */}
        <div className="ce-card">
          {/* Step Pill */}
          <div className="ce-step-pill">
            <span className="ce-step-current">{otp ? "02" : "01"}</span>
            <span className="ce-step-total">OF 02</span>
          </div>

          {/* Heading */}
          <h2 className="ce-card-title">
            {otp ? "ENTER OTP" : "MOBILE NUMBER"}
          </h2>
          <p className="ce-card-description">
            {otp
              ? `Sent to ${PhoneNo}`
              : "We will send a one-time code to continue."}
          </p>

          {/* Form Area */}
          <form onSubmit={otp ? varifyOtp : handleClick} className="ce-form">
            <div className="ce-input-group">
              <label className="ce-input-label">
                {otp ? <Lock size={15} /> : <Phone size={15} />}
                <span>{otp ? "OTP" : "PHONE"}</span>
              </label>

              <div className="ce-input-field-wrapper">
                {!otp ? (
                  <input
                    type="tel"
                    className="ce-input-field"
                    placeholder="Enter phone number"
                    value={PhoneNo}
                    disabled={otp}
                    onChange={(e) =>
                      setPhoneNo(e.target.value.replace(/\D/g, "").slice(0, 10))
                    }
                    required
                  />
                ) : (
                  <input
                    ref={otpInputRef}
                    type="text"
                    className="ce-input-field ce-otp-input"
                    placeholder="• • • • • •"
                    maxLength={6}
                    value={twofactor_code}
                    autoComplete="one-time-code"
                    inputMode="numeric"
                    onChange={(e) =>
                      settwofactor_code(
                        e.target.value.replace(/\D/g, "").slice(0, 6)
                      )
                    }
                    required
                    autoFocus
                  />
                )}
              </div>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="ce-submit-btn"
              disabled={isLoading1}
            >
              {isLoading1 ? (
                <Spinner animation="border" size="sm" variant="light" />
              ) : (
                <>
                  <Sparkles size={18} />
                  <span>{otp ? "Verify & Play" : "Send OTP"}</span>
                </>
              )}
            </button>
          </form>

          {/* Card Footer */}
          {otp && (
            <div className="ce-card-footer">
              <div className="ce-resend-text">
                {seconds > 0 ? (
                  <>
                    Resend in <strong>{seconds}s</strong>
                  </>
                ) : (
                  <button
                    type="button"
                    className="ce-text-link"
                    onClick={handleClick}
                    disabled={isLoading1}
                  >
                    Resend OTP
                  </button>
                )}
              </div>

              <button
                type="button"
                className="ce-text-link ce-change-number"
                onClick={() => {
                  setOtp(false);
                  settwofactor_code("");
                }}
              >
                <ArrowLeft size={14} /> Change number
              </button>
            </div>
          )}
        </div>

        {/* Bottom Feature Badges */}
        <div className="ce-bottom-stats">
          <div className="ce-stat-card">
            <h3>10K+</h3>
            <p>PLAYERS</p>
          </div>
          <div className="ce-stat-card">
            <h3>&lt; 2 MIN</h3>
            <p>PAYOUTS</p>
          </div>
          <div className="ce-stat-card">
            <h3>24×7</h3>
            <p>SUPPORT</p>
          </div>
        </div>
      </div>
    </div>
  );
}